/* global document:true */
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import App from './components/App';

// allows module loading instead of reloading the page
if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.jsx